import { atomWithStorage } from 'jotai/utils';

export const currentConfigTabAtom = atomWithStorage('currentConfigTab', 0);
